// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import MyListOutline from '../_raw/ui/icon_my_list_outline.svg';
import withIconProps from '../withIconProps';

export default withIconProps(MyListOutline);
